var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTopArrowBtn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9703 0.54601L11.6545 15.6713C11.5351 16.09 11.2782 16.1091 11.087 15.7263L7.48111 8.50483L0.297399 5.62753C-0.105967 5.46596 -0.100973 5.22418 0.324346 5.08222L15.4294 0.0404699C15.8476 -0.0991316 16.0875 0.135289 15.9703 0.54601ZM13.8403 2.24152L4.16685 5.47035L8.62771 7.25709L11.0342 12.0763L13.8403 2.24152Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTopArrowBtn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/top-arrow-btn.6b0cb2a801428294188daf636f9dca53.svg";